import React, { FC, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { IMeetingConfirmation, IUser, getMemberIcon, getShortUserName } from '@utils';
import { Chip } from './Chip';
import { ReadOnlyChip } from './ReadOnlyChip';
import '../../../../../styles/components/chip.scss';

interface MemberChipProps {
  member: IUser;
  isCloseList: boolean;
  readOnly: boolean;
  initiatorId: number;
  setListOpen: (value: boolean) => void;
  onDeleteMember: (id: number) => void;
  confirmations: IMeetingConfirmation[];
}

export const MemberChip: FC<MemberChipProps> = observer(({
  member, isCloseList, initiatorId, readOnly, setListOpen, onDeleteMember, confirmations,
}) => {
  const onDelete = useCallback(() => {
    isCloseList && setListOpen(false);
    onDeleteMember(member.id);
  }, [member.id]);

  return (
    (!initiatorId || member.id !== initiatorId) && readOnly
      ? (
        <Chip
          label={getShortUserName(member.fullName)}
          remoteWorkIcon={getMemberIcon(member, true, 'confirmation-round tooltip-question')}
          confirmationStatus={confirmations && confirmations.find((elem) => elem.userId === member.id)?.answerStatus}
          onDelete={onDelete}
        />
      )
      : (
        <ReadOnlyChip 
          initiatorId={initiatorId}
          member={member}
          confirmations={confirmations}
        />
      )
  );
});
